import axios from 'axios'
export default {
  state: {
    yearlyPrincipal: {},
    yearlyEarnings: {},
    yearlyAssets: {},
    totalPrincipal: null,
    totalEarning: null,
    totalAssets: null,
    averages: null,
  },
  mutations: {
    SET_YEARLY_PRINCIPAL(state, data) {
      state.yearlyPrincipal[data.year] = data.data
    },
    SET_YEARLY_EARNINGS(state, data) {
      state.yearlyEarnings[data.year] = data.data
    },
    SET_YEARLY_ASSETS(state, data) {
      state.yearlyAssets[data.year] = data.data
    },
    SET_TOTAL_PRINCIPAL(state, data) {
      state.totalPrincipal = data
    },
    SET_TOTAL_EARNING(state, data) {
      state.totalEarning = data
    },
    SET_TOTAL_ASSETS(state, data) {
      state.totalAssets = data
    },
    SET_AVERAGES(state, data) {
      state.averages = data
    },
  },
  actions: {
    fetchYearly({ commit, state }, params) {
      if (
        state.yearlyPrincipal &&
        ((params.type === 'principal' && state.yearlyPrincipal[params.year]) ||
          (params.type === 'earnings' && state.yearlyEarnings[params.year]) ||
          (params.type === 'assets' && state.yearlyAssets[params.year]))
      )
        return true
      return axios
        .get(process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/profiles/financial/yearly', {
          params: {
            year: params.year,
            type: params.type,
          },
        })
        .then((data) => {
          if (params.type === 'principal')
            commit('SET_YEARLY_PRINCIPAL', { year: params.year, data: data.data.data })
          else if (params.type === 'earnings')
            commit('SET_YEARLY_EARNINGS', { year: params.year, data: data.data.data })
          else if (params.type === 'assets')
            commit('SET_YEARLY_ASSETS', { year: params.year, data: data.data.data })
        })
    },
    fetchTotals({ commit }) {
      return axios
        .get(process.env.VUE_APP_SERVER_BASE_URL + 'api/v1/profiles/financial')
        .then((data) => {
          commit('SET_TOTAL_PRINCIPAL', data.data.capital)
          commit('SET_TOTAL_EARNING', data.data.interest)
          commit('SET_TOTAL_ASSETS', data.data.assets)
          commit('SET_AVERAGES', data.data.totals)
        })
    },
  },
  getters: {},
}
